import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TfTypeaheadService } from "./services/typeahead.service";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
    ],
    providers: [
        TfTypeaheadService
    ]
})
export class TfTypeaheadModule {
}
